import React from 'react';

interface SidebarProgressBarProps {
  current: number;
  total: number;
  percent: number;
}

const SidebarProgressBar: React.FC<SidebarProgressBarProps> = ({
  current,
  total,
  percent,
}) => {
  return (
    <div className="sidebar-progress">
      <div className="progress-bar-container">
        <div
          className="progress-bar-fill"
          style={{ width: `${percent}%` }}
        />
      </div>
      <div className="progress-text">
        {current} of {total} completed
      </div>
    </div>
  );
};

export default SidebarProgressBar;
